import React from "react"
import contact from "../../../config/contact";
import { Helmet } from "react-helmet"

const Refunds = () => {
    const {maintenanceEmail=""} = contact || {}
    return (
        <div className="legal">
            <Helmet>
                <title>Refund Policy - Shopdm Pay </title>
            </Helmet>
            <div>
                <div className="h1">Shopdm Pay Refund Policy</div>
                <div>Last updated: 1st September 2024</div>
                <div className="margin-top-1em">
                    Dom Software Ltd <b>("we", "our", "us" or "Shopdm Pay")</b> acts as a payment facilitator and technology provider, enabling businesses <b>("Merchants")</b> to accept payments online and offline.
                    <br /><br />
                    The following refund policy applies to all transactions processed through Shopdm Pay, unless the specific Merchant provides a more specific or overriding refund policy at the time of payment.
                </div>

                <div>
                    <div className="h2">1. General Policy on Refunds</div>
                    Shopdm Pay does not sell goods or services directly. Refunds are handled on behalf of the Merchant you transacted with. We are committed to facilitating the resolution of refund requests fairly and promptly.
                    <ul>
                        <li>If a Merchant offers a clearly stated refund policy, we will defer to that policy.</li>
                        <li>If no policy was provided by the Merchant at the time of payment, this general policy shall apply.</li>
                        <li>Refunds may be issued if the product or service was not delivered, was significantly different than advertised, or was canceled prior to delivery.</li>
                    </ul>
                </div>

                <div>
                    <div className="h2">2. Requesting a Refund</div>
                    <ol>
                        <li>To begin a refund request, email the Shopdm Pay Support Team at {maintenanceEmail} with your transaction reference number, Merchant name, and a brief explanation of your refund request.</li>
                        <li>We will contact the Merchant on your behalf and initiate an inquiry. Most refund inquiries are resolved within 3–5 business days.</li>
                        <li>We will notify you of the outcome and, if approved, provide a refund via the original payment method or an alternate method, as appropriate.</li>
                    </ol>
                </div>

                <div>
                    <div className="h2">3. Refund Method and Timing</div>
                    <ol>
                        <li>Refunds will generally be returned to the original payment method (e.g., your credit/debit card or mobile wallet), unless otherwise stated.</li>
                        <li>In some cases, partial refunds or credits may be issued, depending on the specific circumstances.</li>
                        <li>Refunds may take 5–10 business days to appear on your account, depending on your bank or card issuer.</li>
                        <li>Transaction fees are typically non-refundable unless the entire order was canceled or not fulfilled at all.</li>
                    </ol>
                </div>

                <div>
                    <div className="h2">4. Merchant Responsibilities</div>
                    Shopdm Pay expects Merchants using our system to honor their own refund policies and to deliver goods or services in line with customer expectations.
                    <ul>
                        <li>If a Merchant is unresponsive to a refund request, Shopdm Pay reserves the right to temporarily withhold further payouts to that Merchant until the matter is resolved.</li>
                        <li>Merchants who abuse the platform or refuse to cooperate with fair refund resolutions may be suspended or removed from Shopdm Pay.</li>
                    </ul>
                </div>

                <div>
                    <div className="h2">5. Changes To This Policy</div>
                    Any changes to this Policy will be posted to the Shopdm Pay website and, where appropriate, we will notify you of the changes by email.
                    <br /><br />
                    This Policy was last updated: <strong>01/09/2024</strong> {/* Change this date if needed */}
                </div>
            </div>


        </div>
    )
}

export default Refunds